export const aggregateClasses = (baseClass: any, ...mixins: any[]) => {
  class base extends baseClass {
    constructor(...args: any[]) {
      super(...args);
      mixins.forEach((mixin) => {
        copyProps(this, new mixin(...args));
      });
    }
  }
  const copyProps = (target: any, source: any ) => {
    // this function copies all properties and symbols, filtering out some special ones
    Object.getOwnPropertyNames(source)
      .concat(Object.getOwnPropertySymbols(source as any) as any)
      .forEach((prop) => {
        // console.log("prop", prop);
        if (
          !prop.match(
            /^(?:constructor|prototype|arguments|caller|name|bind|call|apply|toString|length)$/,
          )
        )
          // console.log("defineProperty", prop);
          Object.defineProperty(
            target,
            prop,
            Object.getOwnPropertyDescriptor(source as any, prop as any) as any,
          );
      });
  };
  mixins.forEach((mixin) => {
    // outside contructor() to allow aggregation(A,B,C).staticFunction() to be called etc.
    copyProps(base.prototype, mixin.prototype);
    copyProps(base, mixin);
  });
  return base;
};
